<template>
  <div v-editable="blok">
    <div
      class="page-mx module-pt module-pb"
      :class="{
        'module-neg-mt': onlyHasOneButton,
        'pb-0': onlyHasOneHeadline,
      }">
      <ElementTexts :bloks="blok.texts" :textPosition="blok.textPosition" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ModuleRichTextStoryblok } from "@/types";

interface Props {
  blok: ModuleRichTextStoryblok;
}

const props = defineProps<Props>();

const onlyHasOneButton = computed(() => {
  return (
    props.blok.texts.length === 1 &&
    props.blok.texts[0].component === "RichtextButtons"
  );
});
const onlyHasOneHeadline = computed(() => {
  return (
    props.blok.texts.length === 1 &&
    (props.blok.texts[0].component === "RichtextHeadline" ||
      props.blok.texts[0].component === "RichtextDisplay")
  );
});
</script>

<style scoped></style>
